import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AddToCartButton from "../cart/AddToCartButton";
import { productDetailPath } from "../../constants/routes";
import { useLocalizedProduct } from "../../hooks/useLocalizedProduct";

function getDisplayCategory(categories = []) {
  return categories.find((category) => category.slug !== "uncategorized");
}

function ProductCard({ product, showAddToCart = false }) {
  const { t } = useTranslation();
  const localizedProduct = useLocalizedProduct(product);
  if (!localizedProduct) return null;

  const detailPath = productDetailPath(localizedProduct.slug);
  const category = getDisplayCategory(localizedProduct.categories);

  return (
    <article className="caf-product-card group">
      <Link to={detailPath} className="caf-product-card__link">
        <div className="caf-product-card__media">
          {localizedProduct.image ? (
            <img
              src={localizedProduct.image}
              alt={localizedProduct.name}
              className="caf-product-card__image"
              loading="lazy"
              decoding="async"
            />
          ) : (
            <div className="caf-product-card__placeholder" aria-hidden="true" />
          )}
        </div>
        <div className="caf-product-card__body">
          {category ? (
            <p className="caf-product-card__category">{category.name}</p>
          ) : null}
          <h3 className="caf-product-card__title">{localizedProduct.name}</h3>
          {localizedProduct.shortDescription ? (
            <p className="caf-product-card__excerpt">{localizedProduct.shortDescription}</p>
          ) : null}
        </div>
      </Link>

      <div className="caf-product-card__footer">
        {localizedProduct.formattedPrice ? (
          <span className="caf-product-card__price">{localizedProduct.formattedPrice}</span>
        ) : (
          <span className="caf-product-card__price caf-product-card__price--quote">
            {t("Request a Quote")}
          </span>
        )}

        {showAddToCart ? (
          <AddToCartButton
            product={localizedProduct}
            className="caf-btn caf-btn--primary caf-product-card__cart-btn"
          />
        ) : (
          <Link to={detailPath} className="caf-product-card__cta">
            {t("View product")}
          </Link>
        )}
      </div>
    </article>
  );
}

export default ProductCard;
